import UserInfoCell from "../../../components/common/UserInfoCell.jsx";

const BASIS_COLORS = {
  MONTHLY: "#2f6fed",
  DAILY: "#219653",
  WEEKLY: "#8e44ad",
  BIWEEKLY: "#d68910",
  HOURLY: "#b83227",
};

const BASIS_LABELS = {
  MONTHLY: "Monthly",
  DAILY: "Daily",
  WEEKLY: "Weekly",
  BIWEEKLY: "Bi-weekly",
  HOURLY: "Hourly",
};

const PayBasisBadge = ({ payBasis }) => (
  <span
    className="d-inline-flex align-items-center justify-content-center"
    style={{
      backgroundColor: BASIS_COLORS[payBasis] || "#6c757d",
      color: "#fff",
      fontSize: "11px",
      fontWeight: 600,
      padding: "4px 14px",
      borderRadius: "999px",
      lineHeight: 1,
      whiteSpace: "nowrap",
    }}
  >
    {BASIS_LABELS[payBasis] || payBasis}
  </span>
);

const getColumns = (handleEdit) => [
  {
    label: "Employee",
    field: "employee_name",
    className: "fw-semibold",
    sortable: true,
    render: (row) => <UserInfoCell name={row.employee_name} employeeId={row.employee_code} token={row.userToken} />,
  },
  {
    label: "Department",
    field: "department_name",
    sortable: true,
    render: (row) => row.department_name || "N/A",
  },
  {
    label: "Designation",
    field: "designation_name",
    sortable: true,
    render: (row) => row.designation_name || "N/A",
  },
  {
    label: "Pay Basis",
    field: "pay_basis",
    className: "text-center",
    sortable: true,
    render: (row) => <PayBasisBadge payBasis={row.pay_basis} />,
  },
  {
    label: "Action",
    field: "action",
    className: "fw-semibold text-center",
    sortable: false,
    render: (row) => (
      <div className="d-flex gap-2 justify-content-center">
        <div className="cursor-pointer text-primary" onClick={() => handleEdit(row)} title="Change pay basis">
          <span className="material-icons-outlined" style={{ fontSize: "20px" }}>
            edit
          </span>
        </div>
      </div>
    ),
  },
];

export default getColumns;
